import React from 'react'
import { getAdId } from '../../../../utils/ads'

const MSuperbanner = () => {
  const adId = getAdId('superbanner')

  return (
    <div className="m-Superbanner">
      <div className="m-Superbanner-wrapper">
        <div className="m-Superbanner-container">
          <div className="m-Superbanner-content">
            <div className="m-Superbanner-banner m-Superbanner-banner--mobile-possible">
              <div className="m-Superbanner-hint">Werbung</div>
              {adId && <div id={adId} className="m-Superbanner-slot"></div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MSuperbanner
